<template>
    <isc-dialog
        ref="dialog"
        class="nav-dialog"
        :visible.sync="visible"
        width="1100px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        modal-append-to-body
    >
        <isc-container class="nav-dialog__inner">
            <div class="nav-dialog__left">
                <div class="nav-dialog__title">{{ title }}</div>

                <the-nav-menu v-model="type" :navs="navs" />
            </div>

            <slot v-bind="{ type }"></slot>
        </isc-container>
    </isc-dialog>
</template>

<script>
import TheNavMenu from '@/components/desk-header/components/the-nav-menu';

export default {
    name: 'TheNavDialogLayout',

    components: { TheNavMenu },

    props: {
        title: {
            type: String,
            default: '标题'
        },

        navs: {
            type: Array,
            // [value, label]
            // 例如 ["abc", "设置 ABC"]
            default: () => []
        }
    },

    data() {
        return {
            type: '',
            visible: false
        };
    },

    methods: {
        open(type = '') {
            this.type = type;
            this.visible = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.nav-dialog {
    &__inner {
        height: 800px;
        box-shadow: 0px 2px 4px 0px rgba(230, 180, 180, 0.2);
        border-radius: 2px;
    }

    &__left {
        width: 200px;
        border-right: 1px solid #ddd;
    }

    &__title {
        font-size: 16px;
        margin-bottom: 12px;
        color: #999;
        font-weight: bold;
        padding: 20px 0 10px 20px;
    }

    ::v-deep {
        .isc-dialog {
            padding: 0;

            &__body {
                padding: 0;
            }
        }
    }
}
</style>
